export class AuthUnavailableError extends Error {
  constructor() {
    super("Authentication service is temporarily unavailable");
    this.name = "AuthUnavailableError";
  }
}
